import { render } from "./Prices.vue?vue&type=template&id=5a4cf9c4&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"

import "./Prices.vue?vue&type=style&index=0&id=5a4cf9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4cf9c4"]])

export default __exports__